import { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAccountsClient } from 'services/api';
import { SaudiRewardsBalanceDocument } from 'types/api/account.types';

import { accountSaudiRewardsBalanceQuery } from './queries';

export const useSaudiRewardsBalance = () => {
  const accountClient = useAccountsClient();
  const queryClient = useQueryClient();

  const { isPending, isPaused, isError, mutate } = useMutation({
    mutationFn: (input: VariablesOf<typeof SaudiRewardsBalanceDocument>) =>
      accountClient.request(SaudiRewardsBalanceDocument, input),
    onSuccess: (data) => {
      queryClient.setQueryData(
        accountSaudiRewardsBalanceQuery.queryKey,
        data.loyaltyBalance,
        { updatedAt: 0 },
      );
    },
  });

  const balance = queryClient.getQueryData<
    ResultOf<typeof SaudiRewardsBalanceDocument>['loyaltyBalance']
  >(accountSaudiRewardsBalanceQuery.queryKey);

  return {
    balance,
    requestBalance: mutate,
    isError,
    isLoading: isPending && !isPaused,
  };
};
